import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Coins } from "lucide-react";
import { PAYMENT_METHODS } from "@/lib/sections";

export default function FeeDialog({ open, onOpenChange, form, setForm, member, onSave }) {
  const upd = (key, value) => setForm({ ...form, [key]: value });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="fee-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Outfit" }}>
            <Coins className="w-5 h-5 inline mr-2 text-amber-600" />
            Log fee payment{member ? ` — ${member.full_name}` : ""}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label>Period</Label>
              <Input data-testid="fee-period" value={form.period} onChange={(e) => upd("period", e.target.value)} placeholder="2026-02" className="min-h-[44px]" />
            </div>
            <div className="space-y-1.5">
              <Label>Amount (€)</Label>
              <Input type="number" step="0.01" data-testid="fee-amount" value={form.amount} onChange={(e) => upd("amount", e.target.value)} className="min-h-[44px]" />
            </div>
            <div className="space-y-1.5">
              <Label>Paid on</Label>
              <Input type="date" data-testid="fee-paid-on" value={form.paid_on} onChange={(e) => upd("paid_on", e.target.value)} className="min-h-[44px]" />
            </div>
            <div className="space-y-1.5">
              <Label>Method</Label>
              <Select value={form.method} onValueChange={(v) => upd("method", v)}>
                <SelectTrigger data-testid="fee-method" className="min-h-[44px]"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {PAYMENT_METHODS.map((p) => <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-1.5">
            <Label>Notes</Label>
            <Textarea data-testid="fee-notes" value={form.notes} onChange={(e) => upd("notes", e.target.value)} rows={2} />
          </div>
          <label className="flex items-center gap-2 text-sm cursor-pointer" data-testid="fee-receipt-row">
            <Checkbox data-testid="fee-send-receipt" checked={form.send_receipt !== false} disabled={!member?.email} onCheckedChange={(v) => upd("send_receipt", !!v)} />
            <span className={member?.email ? "" : "text-muted-foreground"}>
              {member?.email ? `Email a receipt to ${member.email}` : "No parent email on file — receipt can't be sent"}
            </span>
          </label>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="fee-cancel">Cancel</Button>
          <Button onClick={onSave} data-testid="fee-save">Save payment</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
